angular.module 'zc.users', [
  'zc.core'
]




// WEBPACK FOOTER //
// ./src/zenclerk_modules/users/index.js.coffee